import { Link, Outlet, useMatch } from 'react-router-dom';
import { Tabs, Typography, Wrapper } from '@screentone/core';

import { useConvertedProperty } from 'hooks';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';

const TAB_TITLES = {
  '': 'Setup & Identity',
  'publishing-rules': 'Publishing Rules',
  'content-sources': 'Content Sources',
} as const;

type TabValue = keyof typeof TAB_TITLES;

function SiteConfigGeneral() {
  useRequireRoles(ROLE_TYPE.ADMIN);

  const currentProperty = useConvertedProperty();
  const tabMatch = useMatch('/:property/site-config/:tab');
  const tabParam = tabMatch?.params.tab ?? '';
  const activeTab: TabValue = tabParam in TAB_TITLES ? (tabParam as TabValue) : '';

  const basePath = `/${currentProperty ?? ''}/site-config`;

  return (
    <>
      <Typography variant="header2" margin={{ bottom: 'sm' }}>
        {TAB_TITLES[activeTab]}
      </Typography>
      <Tabs role="tablist" value={activeTab} margin={{ top: 'lg' }}>
        <Tabs.Item
          role="tab"
          id="tab-setup-identity"
          aria-controls="tabpanel-general"
          componentEl={Link}
          to={basePath}
          value=""
        >
          {TAB_TITLES['']}
        </Tabs.Item>
        <Tabs.Item
          role="tab"
          id="tab-publishing-rules"
          aria-controls="tabpanel-general"
          componentEl={Link}
          to={`${basePath}/publishing-rules`}
          value="publishing-rules"
        >
          {TAB_TITLES['publishing-rules']}
        </Tabs.Item>
        <Tabs.Item
          role="tab"
          id="tab-content-sources"
          aria-controls="tabpanel-general"
          componentEl={Link}
          to={`${basePath}/content-sources`}
          value="content-sources"
        >
          {TAB_TITLES['content-sources']}
        </Tabs.Item>
      </Tabs>
      <Wrapper id="tabpanel-general" role="tabpanel" padding={{ top: 'sm' }}>
        <Outlet />
      </Wrapper>
    </>
  );
}

export default SiteConfigGeneral;
